import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { DocumentInterface } from '@app/interfaces/document.interface';

@Injectable({ providedIn: 'root' })
export class DocumentsService extends ApiService<DocumentInterface> {
    // @API documents
    protected serviceName = 'documents';

    constructor() {
        super();
        this.initConnection();
    }
}
